export default class Activity {
    public id?: number;
    public code?: string;
    public name?: string;
    public description?: string;
    public dateFrom?: string;
    public dateTo?: string;
    public availability?: ActivityAvailability

    constructor({
                    id,
                    code,
                    name,
                    description,
                    dateFrom,
                    dateTo, availability
                }: any) {
        this.id = id;
        this.code = code || '';
        this.name = name;
        this.description = description;
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
        this.availability = availability
    }
}

export class ActivityAvailability {
    public availability: number;
    public periodOccupancy: PeriodOccupancy[];

    constructor({availability, periodOccupancy}: any) {
        this.availability = availability;
        this.periodOccupancy = periodOccupancy;
    }

}

export class PeriodOccupancy {
    public periodId: number;
    public occupancy: number;

    constructor({periodId, occupancy}: any) {
        this.periodId = periodId;
        this.occupancy = occupancy;
    }
}

export class WriteActivity {
    public id?: number;
    public code?: string;
    public name?: string;
    public description?: string;

    constructor({
                    id,
                    code,
                    name,
                    description
                }: any) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.description = description;
    }
}
